import React, {Component} from 'react';
import {Alert} from 'antd';
import CameraView from './CameraView'
import {LIVE_STREAM_URL, API_URL} from '../constants/configValues'
import {
  CAMERA_SNAPSHOT_FULL
} from '../constants/defaultValues'

class StationCardCamera extends Component {
  render() {
    const {cameras, system} = this.props
    const content = cameras.length === 0
      ? <Alert message="Chưa cài đặt camera!" type="info"/>
      : cameras.map((cam) => {
        const live_url = `${LIVE_STREAM_URL}/hls/${cam.ID}/index.m3u8`
        const snapshot = `${API_URL}/v1/systems/${system.ID}/camera/${cam.ID}/online/snapshot/${CAMERA_SNAPSHOT_FULL}/0`;
        return <CameraView key={cam.ID} id={cam.ID} mode="live" live={live_url} snapshot={snapshot} name={cam.Name}/>
      })
    return (<div>{content}</div>)
  }
}

export default StationCardCamera;
/* http://giamsat.vtvcab.vn:8080/hls/dd189d8e-9ebf-3a39-ae84-8505671756db.m3u8 */



// WEBPACK FOOTER //
// ./src/components/StationCardCamera.js